// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"0daa95d4","245":"0daa95d4","332":"0daa95d4","527":"f1e10041","545":"8fac4e71","881":"f3f76a35","882":"ba7d6202","987":"f6f50f9a"}[chunkId] + ".chunk.js";
};